import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jetrails/sg.awbridal.com/html/src/components/PaymentMethod/paymentMethod.js");
